let store = {
    params: [
        {
            name: 'Temperature',
            unit: '°C',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 29.9'
                },
                {
                    mod: 3,
                    value: '30 - 31.9'
                },
                {
                    mod: 2,
                    value: '32 - 33.9'
                },
                {
                    mod: 1,
                    value: '34 - 35.9'
                },
                {
                    mod: 0,
                    value: '36 - 38.4'
                },
                {
                    mod: 1,
                    value: '38.5 - 38.9'
                },
                {
                    mod: 3,
                    value: '39 - 40.9'
                },
                {
                    mod: 4,
                    value: '< 41'
                }
            ]
        },
        {
            name: 'Heart Rate',
            unit: 'bpm',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 39'
                },
                {
                    mod: 3,
                    value: '40 - 54'
                },
                {
                    mod: 2,
                    value: '55 - 69'
                },
                {
                    mod: 0,
                    value: '70 - 109'
                },
                {
                    mod: 2,
                    value: '110 - 139'
                },
                {
                    mod: 3,
                    value: '140 - 179'
                },
                {
                    mod: 4,
                    value: '> 180'
                }
            ]
        },
        {
            name: 'Respiration Rate',
            unit: 'rpm',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 5'
                },
                {
                    mod: 2,
                    value: '6 - 9'
                },
                {
                    mod: 1,
                    value: '10 - 11'
                },
                {
                    mod: 0,
                    value: '12 - 24'
                },
                {
                    mod: 1,
                    value: '25 - 34'
                },
                {
                    mod: 3,
                    value: '35 - 49'
                },
                {
                    mod: 4,
                    value: '> 50'
                }
            ]
        },
        {
            name: 'Serum Na',
            unit: 'mmol/l',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 110'
                },
                {
                    mod: 3,
                    value: '111 - 119'
                },
                {
                    mod: 2,
                    value: '120 - 129'
                },
                {
                    mod: 0,
                    value: '130 - 149'
                },
                {
                    mod: 1,
                    value: '150 - 154'
                },
                {
                    mod: 2,
                    value: '155 - 159'
                },
                {
                    mod: 3,
                    value: '160 - 179'
                },
                {
                    mod: 4,
                    value: '> 180'
                }
            ]
        },
        {
            name: 'Serum K++',
            unit: 'mmol/l',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 2.5'
                },
                {
                    mod: 2,
                    value: '2.5 - 2.9'
                },
                {
                    mod: 1,
                    value: '3 - 3.4'
                },
                {
                    mod: 0,
                    value: '3.5 - 5.4'
                },
                {
                    mod: 1,
                    value: '5.5 - 5.9'
                },
                {
                    mod: 3,
                    value: '6 - 6.9'
                },
                {
                    mod: 4,
                    value: '> 7'
                }
            ]
        },
        {
            name: 'Serum Creatinine',
            unit: 'mg/100ml (x2 for acute renal failure)',
            chosen: -1,
            values: [
                {
                    mod: 2,
                    value: '< 0.6'
                },
                {
                    mod: 0,
                    value: '0.6 - 1.5'
                },
                {
                    mod: 2,
                    value: '1.5 - 1.9'
                },
                {
                    mod: 3,
                    value: '2 - 3.4'
                },
                {
                    mod: 4,
                    value: '> 3.5'
                }
            ]
        },
        {
            name: 'Hematocrit',
            unit: '%',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 20'
                },
                {
                    mod: 2,
                    value: '20 - 29.9'
                },
                {
                    mod: 0,
                    value: '30 - 45.9'
                },
                {
                    mod: 1,
                    value: '46 - 49.9'
                },
                {
                    mod: 2,
                    value: '50 - 59.9'
                },
                {
                    mod: 4,
                    value: '> 60'
                }
            ]
        },
        {
            name: 'White blood cell count',
            unit: 'total/mm3 ×1000',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 1'
                },
                {
                    mod: 2,
                    value: '1 - 2.9'
                },
                {
                    mod: 0,
                    value: '3 - 14.9'
                },
                {
                    mod: 1,
                    value: '15 - 19.9'
                },
                {
                    mod: 2,
                    value: '20 - 39.9'
                },
                {
                    mod: 4,
                    value: '> 40'
                }
            ]
        },
        {
            name: 'Serum bicarbonate',
            unit: 'venous, mmol/l',
            chosen: -1,
            values: [
                {
                    mod: 4,
                    value: '< 15'
                },
                {
                    mod: 3,
                    value: '15 - 17.9'
                },
                {
                    mod: 2,
                    value: '18 - 21.9'
                },
                {
                    mod: 0,
                    value: '22 - 31.9'
                },
                {
                    mod: 1,
                    value: '32 - 40.9'
                },
                {
                    mod: 3,
                    value: '41 - 51.9'
                },
                {
                    mod: 4,
                    value: '> 52'
                }
            ]
        }
    ]
}

export default store